import api from './api'
import type { GroupPlaySlot } from '../constants/groupPlay'
import type { LeagueTeamName } from '../constants/teamNames'

export interface CreateUserPayload {
  username: string
  email?: string
  discordId?: string
}

export interface CreateUserResponse {
  message: string
  user: {
    id: number
    username: string
    email: string | null
    discordId: string | null
    createdAt: string
  }
}

/**
 * Payload used by admin tools to assign or clear a competitor's team and group-play slot.
 */
export interface UpdateUserAssignmentsPayload {
  leagueTeamName: LeagueTeamName | null
  groupPlaySlot: GroupPlaySlot | null
}

/**
 * Minimal user shape returned after an admin assignment change.
 */
export interface UpdateUserAssignmentsResponse {
  message: string
  user: {
    id: number
    leagueTeamName: LeagueTeamName | null
    groupPlaySlot: GroupPlaySlot | null
    updatedAt: string
  }
}

/**
 * Creates a manual user account for local/testing workflows.
 */
export async function createUser(payload: CreateUserPayload): Promise<CreateUserResponse> {
  const response = await api.post<CreateUserResponse>('/users', payload)
  return response.data
}

/**
 * Updates the saved league team and group-play assignments for a competitor.
 */
export async function updateUserAssignments(
  userId: number,
  payload: UpdateUserAssignmentsPayload
): Promise<UpdateUserAssignmentsResponse> {
  const response = await api.patch<UpdateUserAssignmentsResponse>(`/users/${userId}/assignments`, payload)
  return response.data
}




